<template>
	<div>
		<app-layout>
			<template v-slot:header>
				<Header :title="$t('stundent_club_events')" :isFilter="false" />
			</template>
			<template v-slot:header-mobile>
				<HeaderMobile :title="$t('stundent_club_events')" :isFilter="false" />
			</template>
            <b-row>
                <b-col cols="12">
                    <b-card
                        header="Etkinlik Bilgileri">
                        <b-card-text>
                            <b-row>
                                <b-col cols="12" md="6" lg="4">
                                    <b-form-group :label="$t('club_name')">
									<span class="font-weight-bolder">Yapay Zeka Kulübü</span>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" lg="4">
                                    <b-form-group :label="$t('event_name')">
                                        <span class="font-weight-bolder">Yapay Zeka Kulübü Kapadokya Gezisi</span>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" lg="4">
                                    <b-form-group :label="$t('event_type')">
                                        <span class="font-weight-bolder">Gezi</span>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" lg="4">
                                    <b-form-group :label="$t('event_format')">
                                        <span class="font-weight-bolder">Kurum Dışı</span>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" lg="4">
                                    <b-form-group :label="$t('event_start_date')">
                                        <span class="font-weight-bolder">14.11.2025</span>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" lg="4">
                                    <b-form-group :label="$t('event_end_date')">
                                        <span class="font-weight-bolder">16.11.2025</span>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" lg="4">
                                    <b-form-group :label="$t('event_location')">
                                        <span class="font-weight-bolder">Nevşehir</span>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" lg="4">
                                    <b-form-group :label="$t('number_of_participants')">
                                        <span class="font-weight-bolder">12</span>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" lg="4">
                                    <b-form-group :label="$t('external_participation')">
                                        <span class="font-weight-bolder">0</span>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" lg="4">
                                    <b-form-group :label="$t('speaker')">
                                        <span class="font-weight-bolder">Lorem Ipsium</span>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" lg="4">
                                    <b-form-group :label="$t('sponsor')">
                                        <span class="font-weight-bolder">Lorem Ipsium</span>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" lg="4">
                                    <b-form-group :label="$t('transport_audio_video_systems')">
                                        <span class="font-weight-bolder">Lorem Ipsium</span>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" lg="4">
                                    <b-form-group :label="$t('budget_items')">
                                        <span class="font-weight-bolder">Lorem Ipsium</span>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" lg="4">
                                    <b-form-group :label="$t('material_requests')">
                                        <span class="font-weight-bolder">Lorem Ipsium</span>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" lg="4">
                                    <b-form-group :label="$t('registration_date_just')">
                                        <span class="font-weight-bolder">10.10.2025</span>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" lg="4">
                                    <b-form-group :label="$t('purpose')">
                                        <span class="font-weight-bolder">It is a long established fact that a
                                            reader will be distracted by the readable content
                                            of a page when looking at its layout. The point of
                                            using Lorem Ipsum is that it has a more-or-less normal
                                            distribution of letters, as opposed to using 'Content here,
                                            content here', making it look like readable English.
                                        </span>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" lg="4">
                                    <b-form-group :label="$t('requirement_list')">
                                        <span class="font-weight-bolder">
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                            Pellentesque non eros ac nulla facilisis condimentum.
                                            Mauris volutpat elit eu libero sagittis commodo.
                                            Nam efficitur sapien non iaculis sagittis.
                                        </span>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" lg="4">
                                    <b-form-group :label="$t('academic_advisor_approval_date')">
                                        <span class="font-weight-bolder">15.10.2025</span>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-card-text>
                    </b-card>
                </b-col>
                <b-col cols="12" class="mt-2">
                    <b-card
                        header="Onay İşlemleri">
                        <b-card-text>
                            <ValidationObserver ref="updateForm">
                            <b-row>
                                <b-col cols="12" md="6" class="mr-2">
                                    <ValidationProvider name="status" rules="required" v-slot="{ valid, errors }">
                                        <b-form-group :label="$t('status')">
                                            <multi-selectbox
                                                v-model="approveFormData.status"
                                                :multiple="false"
                                                :validate-error="errors[0]"
                                                :options="statusOptions"/>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col cols="12" md="6" class="mr-2">
                                    <ValidationProvider name="status" rules="required" v-slot="{ valid, errors }">
                                        <b-form-group :label="$t('explanation')">
                                            <b-form-input type="text"
                                                          v-model="approveFormData.explanation"
                                                          :state="errors[0] ? false : (valid ? true : null)" />
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col cols="12" md="12">
                                    <b-button variant="primary">{{$t('save')}}</b-button>
                                </b-col>
                            </b-row>
                            </ValidationObserver>
                        </b-card-text>
                    </b-card>
                </b-col>
                <b-col cols="12" class="mt-2">
                    <b-table :empty-text="$t('there_are_no_records')"
                             bordered
                             striped
                             responsive
                             :items="tableItems"
                             :fields="tableFields"
                             show-empty
                             sort-by="rank"
                             class="mb-3 table-dropdown no-scrollbar border rounded" />
                </b-col>
            </b-row>
		</app-layout>
	</div>
</template>
<script>
	// Template
	import AppLayout from "@/layouts/AppLayout";
	import Header from "@/layouts/AppLayout/Header";
	import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";

	// Services

	// Components
    import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox"

// Other

	export default {
		components: {
			AppLayout,
			Header,
			HeaderMobile,
            MultiSelectbox
		},
		data() {
			return {
                statusOptions: [
                    {value: "1", text: this.$t('approved')},
                    {value: "2", text: this.$t('declined')},
                ],
                approveFormData: {},
                tableItems: [],
                tableFields: [
                    {
                        key: 'rank',
                        label: this.toUpperCase('rank')
                    },
                    {
                        key: 'authorized_approvers',
                        label: this.toUpperCase('authorized_approvers')
                    },
                    {
                        key: 'approved_by',
                        label: this.toUpperCase('approved_by')
                    },
                    {
                        key: 'status',
                        label: this.toUpperCase('status')
                    },
                    {
                        key: 'explanation',
                        label: this.toUpperCase('explanation')
                    },
                    {
                        key: 'updated_at',
                        label: this.toUpperCase('updated_at')
                    },
                ]
			}
		},

		metaInfo() {
			return {
				title: this.$t('stundent_club_events')
			}
		},
		created() {
            this.getApproveData()
		},

		methods: {
            getApproveData(){
                this.tableItems.push({
                    rank: "1",
                    authorized_approvers: 'Lorem Ipsium',
                    approved_by: 'Lorem Ipsum',
                    status: 'Onaylandı',
                    explanation: 'Lorem Ipsum',
                    updated_at: '10.10.2025',
                })
                this.tableItems.push({
                    rank: "2",
                    authorized_approvers: 'Lorem Ipsium',
                    approved_by: 'Lorem Ipsum',
                    status: 'Onaylandı',
                    explanation: 'Lorem Ipsum',
                    updated_at: '10.10.2025',
                })
                this.tableItems.push({
                    rank: "3",
                    authorized_approvers: 'Lorem Ipsium',
                    approved_by: 'Lorem Ipsum',
                    status: 'Onaylandı',
                    explanation: 'Lorem Ipsum',
                    updated_at: '10.10.2025',
                })
            }
		},
	};
</script>
